/**
 * Zone.js flags to optimize event handling performance.
 * This file MUST be imported before zone.js in polyfills.ts
 *
 * These settings address browser violations like:
 * - "Added non-passive event listener to a scroll-blocking 'touchstart' event"
 * - Long-running event handlers
 *
 * @see https://angular.io/guide/zone#setting-up-zonejs
 * @see https://www.chromestatus.com/feature/5745543795965952
 */

/**
 * Prevent zone.js from patching passive events without the passive flag.
 * This addresses the "Added non-passive event listener to a scroll-blocking event" warning.
 *
 * Events in this list will be registered with { passive: true } by default,
 * making the page more responsive during scrolling and touch interactions.
 */
(window as any).__zone_symbol__PASSIVE_EVENTS = ['touchstart', 'touchmove', 'touchend', 'touchcancel', 'wheel', 'mousewheel', 'scroll'];

/**
 * Optionally disable patching of specific events that cause performance issues.
 * Uncomment the following if you need to further optimize:
 */
// (window as any).__zone_symbol__UNPATCHED_EVENTS = ['scroll', 'mousemove'];

/**
 * Disable requestAnimationFrame patching for better performance in animations.
 * Only uncomment if you don't need zone.js to trigger change detection on RAF callbacks.
 */
// (window as any).__Zone_disable_requestAnimationFrame = true;
